module.exports = __webpack_public_path__ + "img/Melting_stock.a4bf1ef9.svg";